import { Builder } from '@builder.io/react'
import React from 'react'

interface Item {
  itemText: string
  itemDescriptionText: string
  imageSrc: string
  imgAltText: string
}

interface Props {
  backgroundColor: string
  itemTopicTextColor: string
  itemDescriptionTextColor: string
  enableIcons: boolean
  items: Item[]
}

const SimpleThreeColumnsSimple = ({
  backgroundColor,
  itemTopicTextColor,
  itemDescriptionTextColor,
  items,
  enableIcons
}: Props) => {
  const getIconImage = (item: Item) => {
    if (!enableIcons) return null
    return (
      <div className="mb-4 flex items-center justify-center text-white">
        <img
          className="h-20 w-20 rounded-md sm:h-32 sm:w-32 lg:h-40 lg:w-40"
          src={item.imageSrc || 'https://www.w3.org/WAI/WCAG21/Understanding/img/contrast-phone.png'}
          alt={item.imgAltText}
        />
      </div>
    )
  }

  return (
    <div className="bg-white py-8" style={{ backgroundColor }}>
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-5xl lg:px-8">
        <h2 className="sr-only">placeholder topic.</h2>
        <dl className="grid grid-cols-3 gap-4 space-y-10 space-y-0">
          {items?.map((item, i) => (
            <div key={i} className="text-center">
              <dt>
                {getIconImage(item)}
                {/* <p className="mt-5 text-lg font-medium leading-6 text-gray-900 text-center" style={{ color: itemTopicTextColor }}>
                  {item.itemText}
                </p> */}
                <h5 style={{ color: itemTopicTextColor }}>{item.itemText}</h5>
              </dt>
              <dd className="mx-auto mt-2 text-center text-sm lg:w-4/5" style={{ color: itemDescriptionTextColor }}>
                {item.itemDescriptionText}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  )
}

export default SimpleThreeColumnsSimple

Builder.registerComponent(SimpleThreeColumnsSimple, {
  name: 'SimpleThreeColumnsSimple',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'lightgreen'
    },
    {
      name: 'itemTopicTextColor',
      type: 'color',
      defaultValue: '#004355'
    },
    {
      name: 'itemDescriptionTextColor',
      type: 'color',
      defaultValue: 'gray'
    },
    {
      name: 'enableIcons',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'items',
      type: 'list',
      defaultValue: [
        {
          itemText: 'No hidden fees',
          itemDescriptionText: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores impedit perferendis',
          imgSrc: null,
          imgAltText: ''
        }
      ],
      subFields: [
        { name: 'itemText', type: 'text', defaultValue: 'No hidden fees' },
        {
          name: 'itemDescriptionText',
          type: 'text',
          defaultValue: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores impedit perferendis'
        },
        { name: 'imageSrc', type: 'file', defaultValue: null },
        { name: 'imgAltText', type: 'text', defaultValue: '' }
      ]
    }
  ]
})
